angular.module('filters').filter('month', ["Months", function(Months) {
  return function(number) {
    if (number) {
      return Months[number - 1][1];
    }
  };
}]);
